import { useState } from "react";

const Tabs = ({ tabs, defaultTab, onChange, className = "" }) => {
  const firstId = defaultTab ?? tabs[0]?.id;
  const [activeId, setActiveId] = useState(firstId);

  const handleSelect = (id) => {
    setActiveId(id);
    onChange?.(id);
  };

  const activeTab = tabs.find((t) => t.id === activeId) ?? tabs[0];

  return (
    <div className={`flex flex-col ${className}`}>
      <div
        className="flex items-center justify-start flex-row gap-0 border-b border-[var(--theme-border)] overflow-x-auto scrollbar-hide"
        role="tablist"
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeId === tab.id}
            aria-controls={`tabpanel-${tab.id}`}
            id={`tab-${tab.id}`}
            type="button"
            className={`flex-1 md:flex-initial shrink-0 whitespace-nowrap px-4 py-2 font-medium border-b-2 transition-colors bg-transparent ${
              activeId === tab.id
                ? "border-[var(--theme-primary)] text-[var(--theme-primary)]"
                : "border-transparent text-[var(--theme-text-muted)] hover:text-[var(--theme-text)] hover:border-[var(--theme-border)]"
            }`}
            onClick={() => handleSelect(tab.id)}
          >
            <span className="text-sm">{tab.label}</span>
          </button>
        ))}
      </div>
      <div
        role="tabpanel"
        id={`tabpanel-${activeId}`}
        aria-labelledby={`tab-${activeId}`}
        className="flex-1 pt-2"
      >
        {activeTab?.children}
      </div>
    </div>
  );
};

export default Tabs;
